<template>
  <div class="splash-screen" v-if="show">
    <img
      style="width: 55%"
      src="@/assets/img/shomalamlak_transparent.gif"
      alt="Splash"
    />
    <div class="splashDetails">
      <div class="detailsTitle">
        <div>شمال املاک</div>
        اولین، تخصصی‌ترین، شمالی‌ترین
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

const show = ref(true);

onMounted(() => {
  // مثلاً بعد از 3 ثانیه پنهانش کن
  setTimeout(() => {
    show.value = false;
  }, 4000);
});
</script>

<style scoped lang="scss">
.dark {
  .splash-screen {
    background: #101a23;
    color: #fff;
  }
}
.splash-screen {
  position: relative;
  position: fixed;
  inset: 0;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999999;
}

img {
  position: absolute;
  left: 0;
  right: 0;
  top: 40%;
  transform: translateY(-40%);
  margin: 0 auto;
}

.splashDetails {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 33%;

  .detailsTitle {
    text-align: center;
    font-size: 0.915rem;
    margin-bottom: 8px;

    div {
      font-family: "iranyekanB", sans-serif;
      font-size: 0.975rem;
      margin-bottom: 4px;
    }
  }

  .setailsSubtitle {
    font-size: 0.835rem;
    color: #858585;
    text-align: center;

    span {
      font-family: "iranyekanB", sans-serif;
      color: #176af3;
    }
  }
}

@media (min-width: 700px) {
  .splash-screen {
    display: none;
  }
}
</style>
